export const versionApp = 'en'
export const defaultLocale = 'en'
export let locales = []

if (versionApp === 'pl') {
  locales = [
    {
      code: 'pl',
      name: 'Polski',
      dir: 'ltr'
    }
  ]
} else {
  locales = [
    {
      code: 'en',
      name: 'English',
      dir: 'rtl'
    },
    {
      code: 'de',
      name: 'Deutsch',
      dir: 'ltr'
    },
    {
      code: 'fr',
      name: 'Français',
      dir: 'ltr'
    },
    {
      code: 'it',
      name: 'Italiano',
      dir: 'rtl'
    },
    {
      code: 'sk',
      name: 'Slovensky',
      dir: 'ltr'
    },
    {
      code: 'es',
      name: 'Español',
      dir: 'rtl'
    },
    {
      code: 'hu',
      name: 'Magyar',
      dir: 'rtl'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/config/i18n.js